<script lang="ts">
  import Router, { location } from 'svelte-spa-router';
  import { session } from './lib/session';
  import AuthorizationPage from './routes/AuthorizationPage.svelte';
  import LoginPage from './routes/LoginPage.svelte';
  import HomePage from './routes/HomePage.svelte';
  import CatalogPage from './routes/CatalogPage.svelte';
  import SectionPage from './routes/SectionPage.svelte';
  import MaterialPage from './routes/MaterialPage.svelte';
  import FavoritesPage from './routes/FavoritesPage.svelte';
  import RecentPage from './routes/RecentPage.svelte';
  import SchedulePage from './routes/SchedulePage.svelte';
  import ProfilePage from './routes/ProfilePage.svelte';
  import ReferralPage from './routes/ReferralPage.svelte';
  import AdminEntryPage from './routes/AdminEntryPage.svelte';
  import AdminDashboardPage from './routes/AdminDashboardPage.svelte';
  import AdminUserDetailPage from './routes/AdminUserDetailPage.svelte';
  import AdminMaterialEditPage from './routes/AdminMaterialEditPage.svelte';
  import AdminCategoryEditPage from './routes/AdminCategoryEditPage.svelte';
  import AdminMaterialNewPage from './routes/AdminMaterialNewPage.svelte';
  import AdminCategoryNewPage from './routes/AdminCategoryNewPage.svelte';
  import AdminProductNewPage from './routes/AdminProductNewPage.svelte';
  import AdminProductEditPage from './routes/AdminProductEditPage.svelte';
  import AdminPaymentsPage from './routes/AdminPaymentsPage.svelte';
  import AdminPaymentDetailPage from './routes/AdminPaymentDetailPage.svelte';
  import AdminActivityPage from './routes/AdminActivityPage.svelte';
import AdminCommentsPage from './routes/AdminCommentsPage.svelte';
  import AdminSettingsPage from './routes/AdminSettingsPage.svelte';
  import AdminReferralsPage from './routes/AdminReferralsPage.svelte';
  import AdminEventNewPage from './routes/AdminEventNewPage.svelte';
  import AdminEventEditPage from './routes/AdminEventEditPage.svelte';
  import EventPage from './routes/EventPage.svelte';
  import NotFoundPage from './routes/NotFoundPage.svelte';
  import BottomNav from './components/BottomNav.svelte';
  import IconSprite from './components/IconSprite.svelte';
  import DevStatusSwitcher from './components/DevStatusSwitcher.svelte';
  import { isInsideTelegram } from './lib/telegram';

  // svelte-spa-router's typings don't yet match Svelte 5's Component type,
  // so we widen to `any` at the boundary. Behavior is unchanged.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const routes: Record<string, any> = {
    '/': AuthorizationPage,
    '/authorization': AuthorizationPage,
    '/login': LoginPage,
    '/home': HomePage,
    '/catalog': CatalogPage,
    '/section/:id': SectionPage,
    '/material/:id': MaterialPage,
    '/favorites': FavoritesPage,
    '/recent': RecentPage,
    '/schedule': SchedulePage,
    '/profile': ProfilePage,
    '/referral': ReferralPage,
    '/admin-entry': AdminEntryPage,
    '/admin/dashboard': AdminDashboardPage,
    '/admin/user/:id': AdminUserDetailPage,
    '/admin/material/new': AdminMaterialNewPage,
    '/admin/material/:id/edit': AdminMaterialEditPage,
    '/admin/category/new': AdminCategoryNewPage,
    '/admin/category/:id/edit': AdminCategoryEditPage,
    '/admin/product/new': AdminProductNewPage,
    '/admin/product/:id/edit': AdminProductEditPage,
    '/admin/payments': AdminPaymentsPage,
    '/admin/payment/:id': AdminPaymentDetailPage,
    '/admin/activity': AdminActivityPage,
  '/admin/comments': AdminCommentsPage,
    '/admin/settings': AdminSettingsPage,
    '/admin/referrals': AdminReferralsPage,
    '/admin/event/new': AdminEventNewPage,
    '/admin/event/:id/edit': AdminEventEditPage,
    '/event/:id': EventPage,
    '*': NotFoundPage,
  };

  // Show the dev switcher only in `vite dev` AND when we're not inside the
  // Telegram WebView. Tree-shaken out of production builds.
  const showDevSwitcher = import.meta.env.DEV && !isInsideTelegram();

  // Derive the active bottom-nav tab from the current URL so BottomNav can
  // live OUTSIDE the router and stay mounted across route changes — that's
  // what lets the sliding indicator animate between pages instead of getting
  // remounted at the new index. Returns null for routes without a nav (login,
  // authorization, admin).
  type NavTab = 'home' | 'catalog' | 'schedule' | 'profile';
  function navTabFromPath(path: string): NavTab | null {
    if (path === '/home' || path === '/recent') return 'home';
    if (
      path === '/catalog' ||
      path === '/favorites' ||
      path.startsWith('/section/') ||
      path.startsWith('/material/')
    )
      return 'catalog';
    if (path === '/schedule') return 'schedule';
    if (path === '/profile') return 'profile';
    return null;
  }
  const activeTab = $derived.by(() => {
    const t = navTabFromPath($location);
    if (!t) return null;
    // Admin drill-in pages: hide user BottomNav so they stay in admin context
    // (came from /admin/dashboard, exit via TopBar «← Назад»). Top-level tab
    // pages (/home, /catalog, /schedule, /profile) keep the nav — admin can
    // still browse the user app.
    if (
      $session?.isAdmin &&
      ($location.startsWith('/material/') ||
        $location.startsWith('/section/') ||
        $location === '/favorites' ||
        $location === '/recent')
    ) {
      return null;
    }
    return t;
  });
</script>

<!-- Спрайт іконок — рівно один раз на застосунок. -->
<IconSprite />


<div class="app-shell">
  <Router {routes} />
  {#if activeTab}
    <BottomNav active={activeTab} />
  {/if}
</div>
{#if showDevSwitcher}
  <DevStatusSwitcher />
{/if}

<style>
  .app-shell {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
</style>
